import classNames from "classnames";
import { FC } from "react";
import { Identity, useAuthContext } from "../../context/authContext";
import styles from "./Profile.module.css";

interface Props {
  className?: string;
  layout: "full" | "compact";
}

const getInitialChar = (s: string): string => {
  return s.charAt(0).toUpperCase();
};

export const getUserInitials = ({ firstName, lastName }: Identity) => {
  return getInitialChar(firstName) + getInitialChar(lastName);
};

const Profile: FC<Props> = ({ className, layout }: Props) => {
  const { identity, avatarUrl } = useAuthContext();

  if (!identity) return;

  return (
    <div className={classNames(styles.profile, className)}>
      {layout === "full" ? (
        <div className={styles.identity}>
          <div className={styles.name}>
            {identity.firstName} {identity.lastName}
          </div>
          <div className={styles.email}>{identity.email}</div>
        </div>
      ) : (
        <div className={styles.avatar}>
          <div className={styles.initials}>
            {avatarUrl ? <img src={avatarUrl} alt="" className={styles.avatarImage} /> : getUserInitials(identity)}
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
